// extracted by mini-css-extract-plugin
export default {"search":"DefaultSearchRenderer_search__8DQ6M","spin":"DefaultSearchRenderer_spin__QYAJ-"};